<template>
    <div>
        <div v-if="!app.isSpinnerVisible">
            <div
                class="d-flex mt-3"
                :class="isMobile ? 'flex-column align-items-center ' : 'flex-row justify-content-center'"
            >
                <div class="m-3">
                    <strong class="font-weight-bold mb-2">{{ $t('s0_language') }}</strong>

                    <editParameterValueComponent
                        :labelOverInput="true"
                        field_type="dropdown"
                        :parameter="app.languageParameter"
                        :value.sync="app.language"
                        :style_inside_dropdown="'width:160px'"
                        @update:value="app.asyncProcess(false, false)"
                    ></editParameterValueComponent>
                </div>

                <div class="m-3">
                    <strong class="font-weight-bold mb-2">{{ $t('s0_market') }}</strong>

                    <editParameterValueComponent
                        :labelOverInput="true"
                        field_type="dropdown"
                        :parameter="app.marketParameter"
                        :value.sync="app.market"
                        :style_inside_dropdown="'width:160px'"
                        @update:value="app.asyncProcess(false, false)"
                    ></editParameterValueComponent>
                </div>
            </div>

            <button
                type="button"
                class="btn mt-3 mb-5"
                style="margin: 50px 0px 50px 0px"
                :class="this.allSelected() ? 'btn-dark' : 'btn-outline-dark'"
                @click="navigateToFamilies()"
            >
                <i v-if="buttonLoading" class="fa fa-spinner fa-spin"></i>
                {{ $t('s0_select_configurators') }}
            </button>
        </div>
    </div>
</template>

<script>
import { app } from "../../application.js";
import editParameterValueComponent from "./../editParameterValue.vue";

export default {
    name: "languageMarketComponent",
    props: ["comesFromunknownPath"],
    data() {
        return {
            app: app,
            window: { width: 0, height: 0 },
            buttonLoading: false
        };
    },
    async beforeMount() {
        await this.app.loadLanguagesAndMarkets();
    },
    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    computed: {
        isMobile: function() {
            let a = this.window.width < 600;
            return a;
        }
    },
    components: { editParameterValueComponent },
    methods: {
        navigateToFamilies() {
            this.buttonLoading = true;
            this.app.navigateToNextStage();
            this.buttonLoading = false;
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        allSelected: function() {
            let allSelected = true;

            if (
                this.app.currentConfiguration.market.id &&
                this.app.currentConfiguration.language.id
            ) {
                return true;
            } else {
                return false;
            }
        }
    }
};
</script>

<style lang="scss">
</style>
